<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Tramos Rutas</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item active">General</li>
                  <li class="breadcrumb-item active">Basico</li>
                  <li class="breadcrumb-item active">Tramos Rutas</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <div class="card">
              <div class="card-header pt-2 pb-2">
                <div class="card-tools">
                  <div class="btn-group">
                    <button
                      @click="create()"
                      v-if="$store.getters.can('cs.tramosRutas.create')"
                      type="button"
                      class="btn btn-primary"
                    >
                      <i class="fas fa-plus"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="card-body p-0">
                <table
                  class="table table-bordered table-striped table-hover table-sm"
                >
                  <thead>
                    <tr>
                      <th>
                        Nombre
                        <input
                          v-model="filtros.nombre"
                          type="text"
                          class="form-control form-control-sm"
                          @keyup="getIndex()"
                        />
                      </th>
                      <th class="col-1">Distancia <small>(Km)</small></th>
                      <th class="col-1">
                        Estado
                        <select
                          v-model="filtros.estado"
                          class="form-control form-control-sm"
                          @change="getIndex()"
                        >
                          <option value="">Todos...</option>
                          <option
                            v-for="estado in ListasForm.estados"
                            :key="estado.numeracion"
                            :value="estado.numeracion"
                          >
                            {{ estado.descripcion }}
                          </option>
                        </select>
                      </th>
                      <th class="col-1">Acción</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="tramoRuta in tramosRutas.data"
                      :key="tramoRuta.id"
                    >
                      <td>{{ tramoRuta.nombre }}</td>
                      <td class="text-center">
                        {{
                          tramoRuta.distancia_km
                            ? `${tramoRuta.distancia_km} Km.`
                            : ""
                        }}
                      </td>
                      <td class="text-center">
                        <span
                          class="badge"
                          :class="[
                            tramoRuta.estado == 1
                              ? 'badge-success'
                              : 'badge-danger',
                          ]"
                        >
                          {{ tramoRuta.nEstado }}
                        </span>
                      </td>
                      <td class="text-right">
                        <div class="btn-group">
                          <button
                            @click="edit(tramoRuta.id)"
                            type="button"
                            class="btn btn-sm btn-primary"
                            v-if="
                              $store.getters.can('cs.tramosRutas.show') ||
                                $store.getters.can('cs.tramosRutas.edit')
                            "
                          >
                            <i class="fas fa-edit"></i>
                          </button>
                          <button
                            @click="destroy(tramoRuta.id, 1)"
                            v-if="
                              tramoRuta.estado == 1 &&
                                $store.getters.can(
                                  'cs.tramosRutas.delete',
                                )
                            "
                            type="button"
                            class="btn btn-sm btn-danger"
                          >
                            <i class="fas fa-times"></i>
                          </button>
                          <button
                            @click="destroy(tramoRuta.id, 2)"
                            v-if="
                              tramoRuta.estado == 2 &&
                                $store.getters.can(
                                  'cs.tramosRutas.delete',
                                )
                            "
                            type="button"
                            class="btn btn-sm btn-success"
                          >
                            <i class="fas fa-check"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer">
                <div class="float-left" v-if="tramosRutas.total">
                  Mostrando del <b>{{ tramosRutas.from }}</b> al
                  <b>{{ tramosRutas.to }}</b> de un total:
                  <b>{{ tramosRutas.total }}</b> Registros
                </div>
                <div class="float-left" v-else>
                  <span class="badge badge-danger">
                    No hay registros para mostrar
                  </span>
                </div>
                <pagination
                  :data="tramosRutas"
                  @pagination-change-page="getIndex"
                  :limit="3"
                  class="float-right m-0"
                ></pagination>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import loading from "@/components/Loading.vue";
import axios from "axios";
import pagination from "laravel-vue-pagination";

export default {
  name: "CsTramosRutasIndex",
  components: {
    loading,
    pagination,
  },
  data() {
    return {
      cargando: false,
      tramosRutas: {},
      filtros: {},
      ListasForm: {},
    };
  },

  methods: {
    getIndex(page = 1) {
      this.cargando = true;
      axios
        .get("/api/cs/tramosRutas?page=" + page, {
          params: this.filtros,
        })
        .then((response) => {
          this.cargando = false;
          this.tramosRutas = response.data;
        })
        .catch((error) => {
          this.$swal({
            icon: "error",
            title: "Ocurrió un error: " + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },

    getEstados() {
      axios.get("/api/lista/1").then((response) => {
        this.ListasForm.estados = response.data;
      });
    },

    create() {
      return this.$router.push({
        name: "/Cs/TramosRutasForm",
        params: { accion: "Crear" },
      });
    },

    edit(id) {
      return this.$router.push({
        name: "/Cs/TramosRutasForm",
        params: { accion: "Editar", id },
      });
    },

    destroy(id, estado) {
      if (estado === 2) {
        this.$swal({
          title: "¿Reactivar tramo?",
          text: "El tramo volverá a estar disponible para asociarlo a rutas.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Si, Reactivar!",
        }).then((result) => {
          if (result.value) {
            axios
              .put("/api/cs/tramosRutas/" + id + "/restore")
              .then((response) => {
                this.$swal({
                  icon: "success",
                  title: response.data.message || "Tramo reactivado",
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                });
                this.getIndex();
              })
              .catch((error) => this.mostrarErrorTramoRuta(error));
          }
        });

        return;
      }

      this.$swal({
        title: "¿Desactivar tramo?",
        html:
          "No podrá usarse en rutas nuevas.<br><strong>No se permitirá si el tramo sigue asociado a rutas activas.</strong>",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, desactivar!",
      }).then((result) => {
        if (result.value) {
          axios
            .delete("/api/cs/tramosRutas/" + id)
            .then((response) => {
              this.$swal({
                icon: "success",
                title: response.data.message || "Tramo desactivado",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              });
              this.getIndex();
            })
            .catch((error) => this.mostrarErrorTramoRuta(error));
        }
      });
    },

    mostrarErrorTramoRuta(error) {
      const data = error.response && error.response.data;
      if (
        error.response &&
        error.response.status === 422 &&
        data &&
        data.rutas
      ) {
        const lista = data.rutas
          .map((r) => `• ${r.nombre} (ID ${r.id})`)
          .join("<br>");

        this.$swal({
          title: "No se puede desactivar el tramo",
          html: `${data.message}<br><br><strong>Rutas que lo usan:</strong><br>${lista}`,
          icon: "error",
          confirmButtonText: "Entendido",
        });

        return;
      }
      this.$swal({
        icon: "error",
        title:
          (data && data.message) || "Ocurrió un error al procesar la solicitud",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 4000,
      });
    },
  },

  beforeMount() {
    this.getEstados();
  },

  mounted() {
    this.getIndex();
  },
};
</script>
